import { Layout, Row, Col, Typography, Space, Divider } from "antd";
import {
  InstagramOutlined,
  FacebookOutlined,
  TwitterOutlined,
  LinkedinOutlined,
  PhoneOutlined,
  MailOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

const { Footer: AntFooter } = Layout;
const { Title, Text, Link } = Typography;

const Footer = ({ contact }) => {
  const contactDetails = contact?.metadata || {};

  return (
    <AntFooter
      className="site-footer"
      style={{
        background: "#111",
        color: "#fff",
        padding: "60px 50px 30px",
      }}
    >
      <Row gutter={[40, 40]}>
        {/* Company Info */}
        <Col xs={24} md={12}>
          <Title
            level={3}
            style={{
              color: "#fff",
              margin: "0 0 8px",
            }}
          >
            NOYA
          </Title>

          <Text
            style={{
              color: "#bbb",
              display: "block",
              marginBottom: 16,
              lineHeight: 1.6,
            }}
          >
            From residential homes to commercial interiors, we create spaces
            that are functional, refined and built around your lifestyle.
          </Text>

          <Space size="large" style={{ marginBottom: 10 }}>
            <a
              href="https://www.instagram.com/noya_interior?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit NOYA on Instagram"
            >
              <InstagramOutlined style={{ fontSize: 20, color: "#fff" }} />
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61577073846778"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit NOYA on Facebook"
            >
              <FacebookOutlined style={{ fontSize: 20, color: "#fff" }} />
            </a>

            {/* <TwitterOutlined style={{ fontSize: 20, color: '#fff' }} />
            <LinkedinOutlined style={{ fontSize: 20, color: '#fff' }} /> */}
          </Space>

          <Title
            level={5}
            style={{
              color: "#fff",
              margin: "15px 0 0",
              fontSize: 13,
              letterSpacing: "1.5px",
            }}
          >
            TRUSTED & CERTIFIED
          </Title>
          <Space size="middle" align="center">
            <img
              src="/certifications/258e844f47188f7fc0ae200e3f0f8b5d-cidb-logo.png"
              alt="CIDB Malaysia"
              style={{
                height: 35,
                width: "auto",
                objectFit: "contain",
              }}
            />

            <img
              src="/certifications/logo-ssm.png"
              alt="SSM"
              style={{
                height: 85,
                width: "auto",
                objectFit: "contain",
              }}
            />

            <img
              src="/certifications/atap-co-logo.png"
              alt="ATAP & CO"
              style={{
                height: 35,
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Space>
        </Col>

        {/* Quick Links */}
        <Col xs={24} md={6}>
          <Title
            level={5}
            style={{
              color: "#fff",
              margin: "0 0 16px",
            }}
          >
            Quick Links
          </Title>

          <Space orientation="vertical">
            <Link href="/#home">Home</Link>
            <Link href="/#portfolio">Portfolio</Link>
            <Link href="/#about">About</Link>
            <Link href="/#contact">Contact</Link>
            {/* <Link>Blog</Link>
            <Link>Careers</Link> */}
          </Space>
        </Col>

        {/* Services */}
        <Col xs={24} md={6}>
          <Title
            level={5}
            style={{
              color: "#fff",
              margin: "0 0 16px",
            }}
          >
            Services
          </Title>

          <Space orientation="vertical">
            <Text style={{ color: "#bbb" }}>Home Renovation</Text>
            <Text style={{ color: "#bbb" }}>Interior Design</Text>
            <Text style={{ color: "#bbb" }}>Kitchen Remodeling</Text>
            <Text style={{ color: "#bbb" }}>Bathroom Remodeling</Text>
            <Text style={{ color: "#bbb" }}>Commercial Design</Text>
            <Text style={{ color: "#bbb" }}>Consultation</Text>
          </Space>
        </Col>
      </Row>

      {/* Contact Info */}
      <Divider style={{ borderColor: "#333", margin: "40px 0" }} />

      <Row gutter={[20, 20]}>
        <Col xs={24} md={8}>
          <Space align="start">
            <PhoneOutlined style={{ color: "#faad14" }} />
            <Text style={{ color: "#bbb" }}>
              {contactDetails.phone || "(555) 123-4567"}
            </Text>
          </Space>
        </Col>

        <Col xs={24} md={8}>
          <Space align="start">
            <MailOutlined style={{ color: "#faad14" }} />
            <Text style={{ color: "#bbb" }}>
              {contactDetails.email || "noya.design.renovation@gmail.com"}
            </Text>
          </Space>
        </Col>

        <Col xs={24} md={8}>
          <Space align="start">
            <EnvironmentOutlined style={{ color: "#faad14" }} />
            <Text style={{ color: "#bbb" }}>
              {contactDetails.address || "123 Design District, New York"}
            </Text>
          </Space>
        </Col>
      </Row>

      {/* Bottom Bar */}
      <Divider style={{ borderColor: "#333", margin: "30px 0" }} />

      <Row justify="space-between" align="middle">
        <Col xs={24} md={12}>
          <Text style={{ color: "#777" }}>
            © 2025 NOYA. All rights reserved.
          </Text>
        </Col>

        <Col
          xs={24}
          md={12}
          className="footer-legal"
          style={{ textAlign: "right" }}
        >
          <Space size="large">
            <Link>Privacy Policy</Link>
            <Link>Terms of Service</Link>
            <Link>Cookie Policy</Link>
          </Space>
        </Col>
      </Row>
    </AntFooter>
  );
};

export default Footer;
